<template>
  <div class="d-flex">
    <b-container fluid class="p-0">
      <b-row no-gutters>
        <b-col cols="4" class="pe-2">
          <v-text-field
            label="Box"
            v-model="rule.number"
            readonly
            dense
            outlined
          />
        </b-col>
        <b-col cols="2" class="pe-2">
          <v-text-field
            v-model="rule.weight"
            label="Weight"
            dense
            outlined
            type="number"
            min="0"
            @change="() => validateMinValue('weight', 0, 'rule')"
          />
        </b-col>
        <b-col cols="2" class="pe-2">
          <v-text-field
            v-model="rule.length"
            label="Length"
            dense
            outlined
            type="number"
            min="0"
            @change="() => validateMinValue('length', 0, 'rule')"
          />
        </b-col>
        <b-col cols="2" class="pe-2">
          <v-text-field
            v-model="rule.width"
            label="Width"
            dense
            outlined
            type="number"
            min="0"
            @change="() => validateMinValue('width', 0, 'rule')"
          />
        </b-col>
        <b-col cols="2" class="pe-2">
          <v-text-field
            v-model="rule.height"
            label="Height"
            dense
            outlined
            type="number"
            min="0"
            @change="() => validateMinValue('height', 0, 'rule')"
          />
        </b-col>
      </b-row>
    </b-container>
    <div class="max-h-65">
      <button
        class="h-40px w-40px btn btn-sm btn-icon btn-light-info btn-hover-light"
        @click="deleteRule"
      >
        <span class="svg-icon">
          <v-icon size="18">mdi-delete</v-icon>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";
export default {
  name: "Action",
  mixins: [fieldValueValidation],
  props: {
    rule: {
      type: Object,
      required: true,
    },
  },
  computed: {
    currentRuleID: function () {
      return this.rule.number;
    },
  },
  methods: {
    deleteRule: function () {
      const self = this;
      const parentRules = self.$parent.currentQuery;
      parentRules.splice(parentRules.indexOf(self.rule), 1);
    },
  },
  watch: {
    currentRuleID: function () {
      this.rule.width = null;
      this.rule.height = null;
      this.rule.length = null;
      this.rule.weight = null;
    },
  },
};
</script>
